module.exports = __webpack_public_path__ + "img/dfcsl.c90f041e.png";